import { Link } from "react-router-dom";
import { catColor, displayCat } from "@/lib/readoo";

// Uniform, elegant terracotta badge (no rainbow) — used on cards.
export function CategoryBadge({ category, className = "" }) {
  return (
    <span
      data-testid={`category-badge-${category}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full bg-brand/12 text-brand font-mono font-semibold uppercase tracking-wider text-[10px] ${className}`}
    >
      {displayCat(category)}
    </span>
  );
}

// Small text label with a subtle brand dot (used in article meta & sidebar).
export function CategoryTag({ category, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1.5 font-mono font-semibold uppercase tracking-wider text-[11px] text-brand ${className}`}>
      <span className="inline-block w-1.5 h-1.5 rounded-full bg-brand" />
      {displayCat(category)}
    </span>
  );
}

// Section header for the grouped home — the ONLY place category color survives, as a tiny dot.
export function SectionHeader({ category, to }) {
  const color = catColor(category);
  return (
    <div className="flex items-center gap-2.5 mb-5">
      <span className="inline-block w-2.5 h-2.5 rounded-full" style={{ backgroundColor: color }} />
      <h2 className="font-serif text-xl sm:text-2xl font-semibold text-onSurface">{displayCat(category)}</h2>
      {to && (
        <Link to={to} data-testid={`section-more-${category}`} className="ml-auto text-xs font-mono text-subtle hover:text-brand transition-colors inline-flex items-center gap-1">
          Vedi tutto →
        </Link>
      )}
    </div>
  );
}

export function StarRating({ value = 0, className = "" }) {
  const full = Math.max(0, Math.min(5, Math.round(value)));
  return (
    <span className={`text-brand tracking-tight ${className}`} aria-label={`${full} su 5`}>
      {"★".repeat(full)}
      <span className="text-hairStrong">{"★".repeat(5 - full)}</span>
    </span>
  );
}
